export enum Autoplay {
    NONE = 'none',
    ATTEMPT_MUTED = 'attemptMuted',
    ATTEMPT_UNMUTED = 'attemptUnmuted',
    ATTEMPT_UNMUTED_THEN_MUTED = 'attemptUnmutedThenMuted'
}
